import { mqTabletPortrait } from '../../utils/mq';

class PmHeroBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.cards = block.querySelector('.pm-hero__cards');
    this.cardsItems = block.querySelectorAll('.pm-hero__cards-item');
    this.content = block.querySelector('.pm-hero__content');
    this.teleportSpan = block.querySelector('.teleport');
    this.contentShowMore = document.createElement('button');
    this.contentShowMore.className = 'pm-hero__content-show-more';
    this.teaser = block.querySelector('.pm-hero__teaser');
    this.right = block.querySelector('.pm-hero__right');
    this.details = block.querySelector('.pm-hero__details');
    this.cta = block.querySelector('.pm-hero__cta');
    this.firstContentItem = block.querySelector('.pm-hero__content > *');

    this.shortenLists();

    if (this.cards) {
      this.initCardsSlider();
    }

    this.teleport = this.teleport.bind(this);
    this.shortenContent = this.shortenContent.bind(this);
    this.teleport();
    setTimeout(() => this.shortenContent());

    mqTabletPortrait.addEventListener('change', this.teleport);
    mqTabletPortrait.addEventListener('change', this.shortenContent);

    this.contentShowMore.addEventListener('click', () => {
      this.content.classList.add('pm-hero__content--expanded');
      this.content.classList.remove('pm-hero__content--has-hidden-content');
      this.contentShowMore.remove();
    });

    addEventListener(
      'resize',
      () => {
        this.content.style.maxHeight = this.details.offsetTop + this.details.offsetHeight + 300 + 'px';
        this.shortenContent();
      },
      { passive: true }
    );

    this.content.style.maxHeight = this.details.offsetTop + this.details.offsetHeight + 300 + 'px';
    this.shortenContent();
  }

  shortenLists() {
    const countriesShort = this.block.querySelector('.pm-hero__locations-list--short');
    const countriesFull = this.block.querySelector('.pm-hero__locations-list--full');

    if (countriesShort) {
      const loadMore = countriesShort.querySelector('strong');

      if (loadMore) {
        loadMore.addEventListener('click', () => {
          countriesShort.classList.add('pm-hero__locations-list--hidden');
          countriesFull.classList.add('pm-hero__locations-list--visible');
        });
      }
    }
  }

  initCardsSlider() {
    const options = {
      autoHeight: true,
      speed: 400,
      spaceBetween: 24,
      slidesPerView: 1,
      navigation: {
        nextEl: this.cards.querySelector('.pm-hero-cards-button--next'),
        prevEl: this.cards.querySelector('.pm-hero-cards-button--prev'),
        disabledClass: 'pm-hero-cards-button--disabled',
      },
      keyboard: {
        enabled: true,
      },
      threshold: 1,
      breakpoints: {
        1024: {
          slidesPerView: Math.min(3, this.cardsItems.length),
        },
        768: {
          slidesPerView: Math.min(2, this.cardsItems.length),
        },
      },
    };

    new Swiper(this.cards, options);
  }

  teleport() {
    if (mqTabletPortrait.matches) {
      if (this.details) {
        if (this.teleportSpan) {
          this.teleportSpan.parentElement.before(this.details);
        } else if (this.teaser) {
          this.teaser.before(this.details);
        }
      }
    } else {
      if (this.details) {
        this.right.append(this.details);
      }
    }
  }

  shortenContent() {
    if (mqTabletPortrait.matches) {
      if (
        !this.content.classList.contains('pm-hero__content--expanded') &&
        this.content.scrollHeight > this.content.offsetHeight + 30
      ) {
        this.content.append(this.contentShowMore);
        this.content.classList.add('pm-hero__content--has-hidden-content');
      }
    } else {
      this.contentShowMore.remove();
      this.content.classList.remove('pm-hero__content--has-hidden-content');
    }
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.pm-hero').forEach((block) => {
  new PmHeroBlock(block);
});